import React from "react";
import Navbar from "./Components/NavBar";
import "./App.css"

const App = () => {
  return (
    <div>
      <Navbar />
    </div>
  );
};

export default App;
